var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 15.25a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm0 1.25a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.808 13.808a.625.625 0 0 1 .884 0l6.75 6.75a.625.625 0 1 1-.884.884l-6.75-6.75a.625.625 0 0 1 0-.884Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;